import { useQuery } from '@tanstack/react-query'
import axios, { AxiosError } from 'axios'

import { GetPatientDto, PatientShort } from 'src/common/types'
import { processApiError } from 'src/common/utils'

const backendUrl = process.env.REACT_APP_MEDPORTAL_API_URL

export const getPatient = async (args: GetPatientDto) => {
    if (!args.id) {
        throw new Error('the patient ID was not provided')
    }
    return axios.post(`${backendUrl}/api/v1/medportal/patients/get`, args, { withCredentials: true }).then((response) => response.data)
}
export const usePatient = (opts: GetPatientDto, enabled = true) => {
    return useQuery<PatientShort, AxiosError>(['patient', opts], () => getPatient(opts), {
        onError: (err) => processApiError('Unable to fetch patient', err),
        enabled,
        staleTime: 10000,
    })
}